import { Card, CardBody, Col } from 'reactstrap'
import { SalesOverviewTitle } from '../../../../Constants/Constants'
import CommonCardHeader from '../../../CommonComponents/CommonCardHeader/CommonCardHeader'
import ReactApexChart from 'react-apexcharts'
import { SalesOverviewChart } from '../../../../Data/General/Widgets/Chart'

const SalesOverview = () => {
  return (
    <Col xl="6" lj="12" className="box-col-6 xl-50">
      <Card>
        <CommonCardHeader title={SalesOverviewTitle} />
        <CardBody>
          <div className="chart-container progress-chart">
            <div id="sales-overview-2">
              <ReactApexChart options={SalesOverviewChart} series={SalesOverviewChart.series} type="line" height={320} />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default SalesOverview